import { RegistryCategory } from '../RegistryCategory';
export class ConditionRegistryCategory extends RegistryCategory {
    get categories() {
        return super.categories;
    }
    get leafs() {
        return super.leafs;
    }
    get allLeafs() {
        return super.allLeafs;
    }
}
